import * as selectors from './customTemplateSelectors';
import * as actions from './customTemplateActions';
import reducer from './customTemplateReducer';

export { selectors, actions, reducer };
